import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("关联员工")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定")

import {ref, reactive, onMounted} from 'vue'
import dayjs from 'dayjs'
import { useStore} from 'vuex'
import Api from '@/http/modules/index'
import { ElMessage } from 'element-plus'
import {Download} from '@element-plus/icons-vue'
import {exportHandle} from '@/utils/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/offer_approvals/list': offerListApi,
  'GET/users/enable':userListApi,
  'PATCH/offer_approvals/bind':bindApi,
  'GET/checkin_approvals/enclosure':downLoadFileApi

} = Api
const tableHeight=window.innerHeight-200
const offerData=ref([])
const isTbLoading=ref(false)
const queryInfo=ref<any>({})
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const queryRef=ref()
const getOfferData=(isReset:boolean=false)=>{
    if(isReset){
        pageInfo.page=1
        queryRef.value.resetFields()
        queryInfo.value={}
    }
    let {spNo,hiredName,key,date}=queryInfo.value
    let {page,size}=pageInfo
    let params={
        spNo:spNo||"",hiredName:hiredName||"",key:key||"",
        page,size,
        submitRangeDate:{
            from:date&&date.length?dayjs(date[0]).format("YYYY-MM-DD"):'',
            to:date&&date.length?dayjs(date[1]).format("YYYY-MM-DD"):'',
        }
    }
    isTbLoading.value=true
    offerListApi(params).then((res:any)=>{
        offerData.value=res.data
        pageInfo.total=res.rowCount
    }).finally(()=>{
        isTbLoading.value=false
    })
}
const showOffer=ref(false)
const showBind=ref(false)
const offerDetail=ref<any>({})
const users=ref([])
const userId=ref("")
const checkOffer=(row:any,handleType:string)=>{
    offerDetail.value=row
    if(handleType=='bind'){ // 关联员工
        userId.value=""
        showBind.value=true
        return
    }
    // 查看
    showOffer.value=true
}
const bindLoading=ref(false)
const bindMember=()=>{
    if(!userId.value){
        ElMessage.warning("请选择员工")
        return
    }
    let params={
        id:offerDetail.value.id,
        userId:userId.value
    }
    bindLoading.value=true
    bindApi(params).then(()=>{
        ElMessage.success('关联成功')
        showBind.value=false
        getOfferData()
    }).finally(()=>{
        bindLoading.value=false
    })
}
const downLoad=({spNo,hiredName}:any)=>{
    let params={
        spNo,name:hiredName
    }
    exportHandle(downLoadFileApi,params)
}
const tableCellClassName=({row,columnIndex}:any)=>{
    if(row.userId!=0&&columnIndex==5){
        return 'staff-text'
    }
}
onMounted(()=>{
    getOfferData()
    userListApi().then((res:any)=>{
        users.value=res
    })
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "Offer转至薪酬-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "queryRef",
              ref: queryRef,
              model: queryInfo.value,
              inline: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "审批编号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryInfo.value.spNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryInfo.value.spNo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "提交时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: queryInfo.value.date,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryInfo.value.date) = $event)),
                      type: "daterange",
                      "range-separator": "To",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "录用人姓名" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryInfo.value.hiredName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryInfo.value.hiredName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "员工名" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryInfo.value.key,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryInfo.value.key) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: " " }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (getOfferData()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (getOfferData(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: offerData.value,
      border: "",
      "max-height": tableHeight,
      class: "mt-10",
      "cell-class-name": tableCellClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          label: "审批编号",
          prop: "spNo"
        }),
        _createVNode(_component_el_table_column, {
          label: "提交时间",
          prop: "submitTime",
          formatter: (row)=>_unref(dayjs)(row.submitTime).format('YYYY-MM-DD HH:mm')
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "所在部门",
          prop: "orgName"
        }),
        _createVNode(_component_el_table_column, {
          label: "录用人姓名",
          prop: "hiredName"
        }),
        _createVNode(_component_el_table_column, {
          label: "员工名",
          prop: "alias"
        }),
        _createVNode(_component_el_table_column, {
          label: "录用部门",
          prop: "hiredDepartment"
        }),
        _createVNode(_component_el_table_column, {
          label: "预入职日期",
          prop: "hiredDate"
        }),
        _createVNode(_component_el_table_column, {
          label: "审批人",
          prop: "approvalName"
        }),
        _createVNode(_component_el_table_column, {
          label: "附件",
          prop: "mediaIds",
          align: "center",
          width: "80"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: ($event: any) => (downLoad(row)),
              size: "small",
              icon: _unref(Download),
              plain: "",
              circle: ""
            }, null, 8, ["onClick", "icon"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          prop: "ops"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: ($event: any) => (checkOffer(row,'check'))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: ($event: any) => (checkOffer(row,'bind'))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, isTbLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      class: "mt-10",
      total: _unref(pageInfo).total,
      small: "",
      currentPage: _unref(pageInfo).page,
      "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      "page-size": _unref(pageInfo).size,
      "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_unref(pageInfo).size) = $event)),
      "page-sizes": [10, 30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _cache[8] || (_cache[8] = ()=>getOfferData()),
      onSizeChange: _cache[9] || (_cache[9] = ()=>getOfferData())
    }, null, 8, ["total", "currentPage", "page-size"]),
    _createVNode(_component_el_dialog, {
      modelValue: showOffer.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showOffer).value = $event)),
      header: false,
      width: "450"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString(offerDetail.value.hiredName) + " 的Offer审批 ", 1),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_scrollbar, { "max-height": "400px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "offer-detail",
              "label-width": "150",
              "label-position": "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "审批编号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.spNo), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "提交时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(dayjs)(offerDetail.value.submitTime).format('YYYY-MM-DD HH:mm')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "所在部门" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.orgName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "录用人姓名(中/英)" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.hiredName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "录用部门" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.hiredDepartment), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "预入职日期" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.hiredDate), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "基础薪资" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.baseSalary), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "公司补助" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.companyAllowance), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "试用期职位津贴" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.jobAllowance), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "转正后职位津贴" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.regularJobAllowance), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "试用期其他补贴" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.otherAllowance), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "转正后其他补贴" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.regularOtherAllowance), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "审批人" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(offerDetail.value.approvalName.join(',')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showBind.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showBind).value = $event)),
      title: "关联员工",
      width: "300"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: bindLoading.value,
          onClick: _cache[12] || (_cache[12] = ($event: any) => (showBind.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: bindLoading.value,
          onClick: bindMember
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          style: {"flex":"1"},
          filterable: "",
          modelValue: userId.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((userId).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.userId,
                label: `${item.realName} (${item.username})`,
                value: item.userId
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})